"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function DualPathHero() {
  return <section id="dual-path-hero" className="relative w-full min-h-[100svh] flex flex-col md:flex-row overflow-hidden bg-background">
      {}
      <div className="relative flex-1 flex flex-col justify-center items-center p-8 md:p-16 transition-all duration-700 ease-in-out md:hover:flex-[1.5] group overflow-hidden bg-gradient-to-br from-background to-primary/10">
        {}
        <div className="absolute inset-0 z-0 opacity-20 group-hover:opacity-40 transition-opacity duration-700 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588353/img/toyota_prius_hero.png)] bg-cover bg-center mix-blend-darken" />
        
        {}
        <div className="relative z-10 text-center flex flex-col items-center gap-6 max-w-xl mt-12 md:mt-0">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-foreground group-hover:scale-105 transition-transform duration-700">
            Drive to Earn
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground font-medium">
            Weekly Gig Rentals for Uber, Lyft & DoorDash. Get on the road and start earning today.
          </p>
          <Button asChild size="lg" className="mt-4 rounded-full h-14 px-8 text-lg shadow-xl shadow-primary/10 group-hover:shadow-primary/25 transition-all">
            <Link to="/RentACarPage">
              Rent a Car <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="relative flex-1 flex flex-col justify-center items-center p-8 md:p-16 transition-all duration-700 ease-in-out md:hover:flex-[1.5] group overflow-hidden bg-secondary text-secondary-foreground">
        {}
        <div className="absolute inset-0 z-0 opacity-30 group-hover:opacity-50 transition-opacity duration-700 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1588353/img/luxury_interior_blurred.png)] bg-cover bg-center mix-blend-overlay blur-[2px] group-hover:blur-none" />
        
        {}
        <div className="relative z-10 text-center flex flex-col items-center gap-6 max-w-xl mb-12 md:mb-0">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-secondary-foreground group-hover:scale-105 transition-transform duration-700">
            Own the Fleet
          </h1>
          <p className="text-lg md:text-xl text-secondary-foreground/80 font-medium">
            Start your own car rental business. Get the training, manuals, and resources you need to succeed.
          </p>
          <Button asChild variant="outline" size="lg" className="mt-4 rounded-full h-14 px-8 text-lg bg-transparent border-secondary-foreground/30 text-secondary-foreground hover:bg-secondary-foreground hover:text-secondary transition-all">
            <Link to="/TrainingAcademyPage">
              Training Academy <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20 flex items-center justify-center size-16 md:size-24 rounded-full backdrop-blur-xl bg-background/70 border border-border shadow-2xl pointer-events-none">
        <span className="text-lg md:text-2xl font-black text-foreground tracking-widest">
          OR
        </span>
      </div>
    </section>;
}